module.exports = __webpack_public_path__ + "static/media/eu-eng.727ada41.jpg";